var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("journey-connection-toggle", {
        attrs: { value: _vm.isDisabled, label: _vm.resource("Bool_Disabled") },
        on: {
          input: function($event) {
            return _vm.$emit("update:is-disabled", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("journey-connection-deduplication-field", {
        attrs: {
          "is-active": !_vm.isDisabled,
          options: _vm.fieldNameOpts,
          value: _vm.fieldName
        },
        on: {
          input: function($event) {
            return _vm.$emit("update:fieldName", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }